import { __decorate } from "tslib";
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { AuthService } from '../../services/auth.service';
import { PaymentService } from '../../services/payment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EcurrenciesService } from '../../services/ecurrencies.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { ActivatedRoute } from '@angular/router';
/**
 * Fees Component
 */
let ProvisionsComponent = class ProvisionsComponent {
    constructor(httpClient, auth, paymentService, sanitizer, ecurrenciesService, changeDetector, themeService, route) {
        this.httpClient = httpClient;
        this.auth = auth;
        this.paymentService = paymentService;
        this.sanitizer = sanitizer;
        this.ecurrenciesService = ecurrenciesService;
        this.changeDetector = changeDetector;
        this.themeService = themeService;
        this.route = route;
        this.fees = {};
        this.currency = 'btc';
        this.buyDataType = 'registered';
        this.sellDataType = 'registered';
        this.buyType = 'registered';
        this.sellType = 'registered';
        this.loggedIn = false;
        this.userData = {};
        this.resultOfService = [];
        this.activeMeanOfPayment = 'bank_slip';
        this.buyFeesLimits = {};
        this.sellFeesLimits = {};
        this.allBuys = {};
        this.allSells = {};
        this.user = {};
        this.ecurrencies = [];
        this.noArrows = false;
        this.screenWidth = 0;
        this.accentColor = '';
        this.firstColor = '';
        this.secondColor = '';
        this.backColor = '';
        this.textColor = '';
        this.tabColor = '';
        this.mainColor = '';
        this.allBuy = [];
        this.allSell = [];
        this.wholeBuyDisabled = false;
        this.wholeSellDisabled = false;
        this.userTypeChoosen = null;
        this.borderRadiusSmaller = '';
        this.showCurrency = false;
        this.inputBackColor = '';
        this.isIndividual = 1;
        this.themeService.getTheme().subscribe((data) => {
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.firstColor = this.themeService.getStyleAttribute('currency_ring_two_color');
            this.secondColor = this.themeService.getStyleAttribute('currency_ring_one_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        });
    }
    ngOnInit() {
        if (this.auth.isAuthenticated()) {
            this.auth.fetchUser().then(() => {
                this.user = JSON.parse(localStorage.getItem('user'));
                this.buyDataType = this.user.user_type_id.type;
                this.sellDataType = this.user.user_type_id.type;
                this.isIndividual = this.user.is_company_user ? 0 : 1;
                if (this.user !== null) {
                    if (this.user['default_mean_of_payment'] !== null && this.user['default_mean_of_payment'] !== '') {
                        this.activeMeanOfPayment = this.user['default_mean_of_payment'];
                    }
                    else {
                        this.activeMeanOfPayment = 'bank_slip';
                    }
                }
                else {
                    this.activeMeanOfPayment = 'bank_slip';
                }
            });
        }
        this.sub = this.route.params.subscribe((params) => {
            this.userTypeChoosen = params['userType'];
            if (this.userTypeChoosen) {
                this.buyType = this.userTypeChoosen;
                this.sellType = this.userTypeChoosen;
            }
            else {
                this.buyType = this.buyDataType;
                this.sellType = this.sellDataType;
            }
        });
        this.ecurrenciesService.getEcurrencies().then((data) => {
            this.ecurrencies = this.ecurrenciesService.getAllEcurrencies();
            this.numberOfEcurrencies = this.ecurrencies.length;
        });
        this.httpClient.get('market/feesandlimits?is_individual=' + this.isIndividual).subscribe((result) => {
            this.allBuy = [];
            this.allSell = [];
            this.wholeBuyDisabled = false;
            this.wholeSellDisabled = false;
            this.fees = result;
            //ukoliko postoji samo jedan nacin placanja prikaze provizije samo za njega
            this.paymentService.getMeansOfPayment().subscribe(requestData => {
                this.resultOfService = JSON.parse(requestData['_body']);
                this.activeMeanOfPayment = (this.resultOfService.length == 1) ? this.resultOfService[0].verbose_id : this.activeMeanOfPayment;
                //ukoliko ma vise od jednog nacina placanja prikaze tabove, gde je aktivan tab onaj koji odgovara default mean of payment-u,
                //ako postoji, ukoliko je default mean of payment null aktivan tab su uplatnice
                if (typeof (this.fees['buy'][this.currency]) == "undefined" || typeof (this.fees['buy'][this.currency][this.activeMeanOfPayment]) == "undefined") {
                    this.wholeBuyDisabled = true;
                }
                else {
                    this.allBuys = this.fees['buy'][this.currency][this.activeMeanOfPayment];
                    this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][this.buyType];
                    this.widthOfBoxesBuy = (Object.keys(this.fees['buy'][this.currency][this.activeMeanOfPayment]).length > 1) ? 96 / Object.keys(this.fees['buy'][this.currency][this.activeMeanOfPayment]).length : 100;
                    this.allBuy = this.transformObject(this.allBuys);
                    if (typeof (this.buyFeesLimits) == "undefined" || this.buyFeesLimits.disabled) {
                        const result = this.checkFeesAndLimits(this.allBuy, 'buy');
                        this.buyType = result.type;
                        this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][this.buyType];
                        this.wholeBuyDisabled = result.disableBuy;
                    }
                }
                if (typeof (this.fees['sell'][this.currency]) == "undefined" || typeof (this.fees['sell'][this.currency][this.activeMeanOfPayment]) == "undefined") {
                    this.wholeSellDisabled = true;
                }
                else {
                    this.allSells = this.fees['sell'][this.currency][this.activeMeanOfPayment];
                    this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType];
                    this.widthOfBoxesSell = (Object.keys(this.fees['sell'][this.currency][this.activeMeanOfPayment]).length > 1) ? 96 / Object.keys(this.fees['sell'][this.currency][this.activeMeanOfPayment]).length : 100;
                    this.allSell = this.transformObject(this.allSells);
                    if (typeof (this.sellFeesLimits) == "undefined" || this.sellFeesLimits.disabled) {
                        const result = this.checkFeesAndLimits(this.allSell, 'sell');
                        this.sellType = result.type;
                        this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType];
                        this.wholeSellDisabled = result.disableSell;
                    }
                    if (typeof (this.sellFeesLimits['min_amount']) != 'undefined') {
                        this.sellFeesLimits['min_amount'] = parseFloat(this.sellFeesLimits['min_amount']);
                    }
                }
            }, error => console.log(error));
        });
        var scrollStep = -window.scrollY / (100 / 15), scrollInterval = setInterval(function () {
            if (window.scrollY != 0) {
                window.scrollBy(0, scrollStep);
            }
            else
                clearInterval(scrollInterval);
        }, 15);
    }
    setCurrency(currency) {
        this.allBuy = [];
        this.allSell = [];
        this.wholeBuyDisabled = false;
        this.wholeSellDisabled = false;
        //ovo se poziva kada se klikne na krug sa btc, ltc ili eth
        this.currency = currency;
        this.paymentService.getMeansOfPayment().subscribe(requestData => {
            this.resultOfService = JSON.parse(requestData['_body']);
            this.activeMeanOfPayment = (this.resultOfService.length == 1) ? this.resultOfService[0].verbose_id : this.activeMeanOfPayment;
            if (typeof (this.fees['buy'][this.currency]) == "undefined" || typeof (this.fees['buy'][this.currency][this.activeMeanOfPayment]) == "undefined") {
                this.wholeBuyDisabled = true;
            }
            else {
                this.allBuys = this.fees['buy'][this.currency][this.activeMeanOfPayment];
                this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][this.buyType];
                this.widthOfBoxesBuy = (Object.keys(this.fees['buy'][this.currency][this.activeMeanOfPayment]).length > 1) ? 96 / Object.keys(this.fees['buy'][this.currency][this.activeMeanOfPayment]).length : 100;
                this.allBuy = this.transformObject(this.allBuys);
                if (typeof (this.buyFeesLimits) == "undefined" || this.buyFeesLimits.disabled) {
                    const result = this.checkFeesAndLimits(this.allBuy, 'buy');
                    this.buyType = result.type;
                    this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][this.buyType];
                    this.wholeBuyDisabled = result.disableBuy;
                }
            }
            if (typeof (this.fees['sell'][this.currency]) == "undefined" || typeof (this.fees['sell'][this.currency][this.activeMeanOfPayment]) == "undefined") {
                this.wholeSellDisabled = true;
            }
            else {
                this.allSells = this.fees['sell'][this.currency][this.activeMeanOfPayment];
                this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType];
                this.sellFeesLimits['min_amount'] = parseFloat(this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType]['min_amount']);
                this.widthOfBoxesSell = (Object.keys(this.fees['sell'][this.currency][this.activeMeanOfPayment]).length > 1) ? 96 / Object.keys(this.fees['sell'][this.currency][this.activeMeanOfPayment]).length : 100;
                this.allSell = this.transformObject(this.allSells);
                if (typeof (this.sellFeesLimits) == "undefined" || this.sellFeesLimits.disabled) {
                    const result = this.checkFeesAndLimits(this.allSell, 'sell');
                    this.sellType = result.type;
                    this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType];
                    this.wholeSellDisabled = result.disableSell;
                }
            }
        }, error => console.log(error));
    }
    buyTypeMethod(type) {
        this.buyType = type;
        this.wholeBuyDisabled = false;
        if (this.activeMeanOfPayment === 'bank_slip') {
            this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][type];
        }
        else if (this.activeMeanOfPayment === 'card') {
            this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][type];
        }
    }
    sellTypeMethod(type) {
        this.sellType = type;
        this.wholeSellDisabled = false;
        if (this.activeMeanOfPayment === 'bank_slip') {
            this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][type];
        }
        else if (this.activeMeanOfPayment === 'card') {
            this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][type];
        }
    }
    setActive(id) {
        if (this.activeMeanOfPayment === id) {
            this.activeMeanOfPayment = id;
        }
        else {
            this.allBuy = [];
            this.allSell = [];
            this.wholeBuyDisabled = false;
            this.wholeSellDisabled = false;
            this.activeMeanOfPayment = id;
            if (typeof (this.fees['buy'][this.currency]) == "undefined" || typeof (this.fees['buy'][this.currency][this.activeMeanOfPayment]) == "undefined") {
                this.wholeBuyDisabled = true;
            }
            else {
                this.allBuys = this.fees['buy'][this.currency][this.activeMeanOfPayment];
                this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][this.buyType];
                this.widthOfBoxesBuy = (Object.keys(this.fees['buy'][this.currency][this.activeMeanOfPayment]).length > 1) ? 96 / Object.keys(this.fees['buy'][this.currency][this.activeMeanOfPayment]).length : 100;
                this.allBuy = this.transformObject(this.allBuys);
                if (typeof (this.buyFeesLimits) == "undefined" || this.buyFeesLimits.disabled) {
                    const result = this.checkFeesAndLimits(this.allBuy, 'buy');
                    this.buyType = result.type;
                    this.buyFeesLimits = this.fees['buy'][this.currency][this.activeMeanOfPayment][this.buyType];
                    this.wholeBuyDisabled = result.disableBuy;
                }
            }
            if (typeof (this.fees['sell'][this.currency]) == "undefined" || typeof (this.fees['sell'][this.currency][this.activeMeanOfPayment]) == "undefined") {
                this.wholeSellDisabled = true;
            }
            else {
                this.allSells = this.fees['sell'][this.currency][this.activeMeanOfPayment];
                this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType];
                this.widthOfBoxesSell = (Object.keys(this.fees['sell'][this.currency][this.activeMeanOfPayment]).length > 1) ? 96 / Object.keys(this.fees['sell'][this.currency][this.activeMeanOfPayment]).length : 100;
                this.allSell = this.transformObject(this.allSells);
                if (typeof (this.sellFeesLimits) == "undefined" || this.sellFeesLimits.disabled) {
                    const result = this.checkFeesAndLimits(this.allSell, 'sell');
                    this.sellType = result.type;
                    this.sellFeesLimits = this.fees['sell'][this.currency][this.activeMeanOfPayment][this.sellType];
                    this.wholeSellDisabled = result.disableSell;
                }
            }
        }
        this.ecurrenciesService.getEcurrencies().then((data) => {
            this.ecurrencies = this.ecurrenciesService.getAllEcurrencies();
        });
    }
    onResize(event) {
        this.noArrows = false;
        this.screenWidth = event.target.innerWidth;
        if (this.numberOfEcurrencies <= 3 && this.screenWidth >= 770) {
            this.noArrows = true;
            this.changeDetector.detectChanges();
        }
    }
    checkFeesAndLimits(feesObject, transactionType) {
        let all = 0;
        const length = feesObject.length;
        let returnValue = {
            'disableBuy': false,
            'disableSell': false,
            'type': 'registered'
        };
        for (let i = 0; i < length; i++) {
            if (feesObject[i].value.disabled) {
                all++;
            }
            else {
                returnValue.type = feesObject[i].key;
                break;
            }
        }
        if (all === length) {
            if (transactionType === 'buy') {
                returnValue.disableBuy = true;
            }
            else if (transactionType === 'sell') {
                returnValue.disableSell = true;
            }
        }
        return returnValue;
    }
    transformObject(object) {
        let newObject = [];
        Object.keys(object).forEach(key => {
            newObject.push({
                "key": key,
                "value": object[key]
            });
        });
        return newObject;
    }
};
ProvisionsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: AuthService },
    { type: PaymentService },
    { type: DomSanitizer },
    { type: EcurrenciesService },
    { type: ChangeDetectorRef },
    { type: WebsiteThemeService },
    { type: ActivatedRoute }
];
__decorate([
    HostListener('window:resize', ['$event'])
], ProvisionsComponent.prototype, "onResize", null);
ProvisionsComponent = __decorate([
    Component({
        selector: 'ecd-provisions',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./provisions.component.html")).default
    })
], ProvisionsComponent);
export { ProvisionsComponent };
